<div class="ptl-table-empty" [class.ptl-table-empty--compact]="compact" [attr.role]="kind === 'error' ? 'alert' : 'status'">
  @switch (kind) {
    @case ('error') {
      <svg class="ptl-table-empty__art" viewBox="0 0 144 96" aria-hidden="true">
        <rect class="art-card" x="12" y="6" width="110" height="78" rx="6" />
        <path class="art-ink" d="M18 6h98a6 6 0 0 1 6 6v8H12v-8a6 6 0 0 1 6-6z" />
        <rect class="art-line" x="24" y="32" width="44" height="4" rx="2" />
        <rect class="art-line" x="24" y="44" width="64" height="4" rx="2" />
        <rect class="art-line" x="24" y="56" width="36" height="4" rx="2" />
        <path class="art-warning" d="M108 46l20 34H88z" />
        <path class="art-warning-mark" d="M108 57v11" />
        <circle class="art-warning-dot" cx="108" cy="74" r="2" />
      </svg>
    }
    @case ('no-results') {
      <svg class="ptl-table-empty__art" viewBox="0 0 144 96" aria-hidden="true">
        <rect class="art-card" x="8" y="8" width="96" height="18" rx="4" />
        <rect class="art-line" x="16" y="15" width="44" height="4" rx="2" />
        <rect class="art-card" x="8" y="34" width="96" height="18" rx="4" />
        <rect class="art-line" x="16" y="41" width="56" height="4" rx="2" />
        <rect class="art-card" x="8" y="60" width="96" height="18" rx="4" />
        <rect class="art-line" x="16" y="67" width="36" height="4" rx="2" />
        <path class="art-handle" d="M112 56l18 18" />
        <circle class="art-lens" cx="98" cy="42" r="19" />
        <path class="art-cross" d="M91 35l14 14M105 35l-14 14" />
      </svg>
    }
    @default {
      <svg class="ptl-table-empty__art" viewBox="0 0 144 96" aria-hidden="true">
        <rect class="art-back" x="26" y="2" width="88" height="24" rx="5" />
        <rect class="art-card" x="18" y="18" width="104" height="30" rx="6" />
        <circle class="art-avatar" cx="34" cy="33" r="7" />
        <rect class="art-line" x="48" y="28" width="48" height="4" rx="2" />
        <rect class="art-line art-line--faint" x="48" y="36" width="32" height="3" rx="1.5" />
        <rect class="art-card" x="8" y="54" width="104" height="32" rx="6" />
        <circle class="art-avatar" cx="25" cy="70" r="8" />
        <circle class="art-person" cx="25" cy="67.5" r="2.5" />
        <path class="art-person" d="M20.5 75a4.5 4.5 0 0 1 9 0z" />
        <rect class="art-line" x="40" y="65" width="52" height="4" rx="2" />
        <rect class="art-line art-line--faint" x="40" y="73" width="36" height="3" rx="1.5" />
        <circle class="art-plus-circle" cx="122" cy="48" r="12" />
        <path class="art-plus" d="M122 42v12M116 48h12" />
      </svg>
    }
  }

  @switch (kind) {
    @case ('error') {
      <h3 class="ptl-table-empty__title subsection-title">{{ 'translations.global.table.error.title' | transloco }}</h3>
      <p class="ptl-table-empty__description fs-body-m">{{ 'translations.global.table.error.description' | transloco }}</p>
      <ptl-button
        class="ptl-table-empty__action"
        type="dark"
        [text]="'translations.global.table.error.retry' | transloco"
        (clicked)="retry.emit()"
      ></ptl-button>
      @if (errorReference) {
        <p class="ptl-table-empty__note fs-body-xs-normal">
          {{ 'translations.global.table.error.reference' | transloco: { reference: errorReference } }}
        </p>
      }
    }
    @case ('no-results') {
      <h3 class="ptl-table-empty__title subsection-title">{{ 'translations.global.table.noResults.title' | transloco }}</h3>
      <p class="ptl-table-empty__description fs-body-m">{{ 'translations.global.table.noResults.description' | transloco }}</p>
      <ptl-button
        class="ptl-table-empty__action"
        type="tertiary-color"
        [text]="'translations.global.table.noResults.clear' | transloco"
        (clicked)="clearFilters.emit()"
      ></ptl-button>
    }
    @default {
      <h3 class="ptl-table-empty__title subsection-title">{{ emptyTitle || ('translations.global.table.empty.title' | transloco) }}</h3>
      <p class="ptl-table-empty__description fs-body-m">
        {{ emptyDescription || ('translations.global.table.empty.description' | transloco) }}
      </p>
    }
  }
</div>
